<div [ngClass]="{'email-copy__header': !isRestyle, 'email-copy__customize-header': isRestyle}">
  {{headerText}}
</div>
<mat-list class="email-copy__list">
  <mat-list-item [attr.data-testid]="emailCopyText + 'email'"
    (click)="goToEmailCopy()"
    (keydown.enter)="$event.target === $event.currentTarget && (goToEmailCopy())">
    @if (emailCopyText) {
      <h4 matListItemTitle class ='email-copy__copy-text'>
        {{emailCopyText}}
      </h4>
    }
    @if (emailCopy) {
      <span matListItemLine class="email-copy__copy">
        <span>{{emailCopy}} </span>
      </span>
    }
    <button mat-icon-button matListItemMeta>
      <img alt="Chevron Icon"
        class="email-copy__chevron-icon"
        src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
    </button>
  </mat-list-item>
  @if (displayAppOption) {
    <mat-divider class="email-copy__divider"></mat-divider>
  }
  @if (displayAppOption) {
    <mat-list-item
      [attr.data-testid]="appCopyText + 'app-copy'"
      (click)="goToAppCopy()"
      (keydown.enter)="$event.target === $event.currentTarget && (goToAppCopy())">
      <h4 matListItemTitle class ='email-copy__copy-text'>
        {{appCopyText}}
      </h4>
      @if (appCopy) {
        <span matListItemLine class="email-copy__copy">
          {{appCopy}}
        </span>
      }
      <button mat-icon-button matListItemMeta>
        <img alt="Chevron Icon"
          class="email-copy__chevron-icon"
          src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
      </button>
    </mat-list-item>
  }
  @if (displayAppOption && displayPushMessageOption) {
    <mat-divider class="email-copy__divider"></mat-divider>
  }
  @if (displayAppOption && displayPushMessageOption) {
    <mat-list-item data-testid="push-message-copy"
      (click)="goToPushMessageCopy()"
      (keydown.enter)="$event.target === $event.currentTarget && goToPushMessageCopy()">
      <h4 matListItemTitle class ='email-copy__copy-text'>
        {{pushMessageText}}
      </h4>
      @if (pushMessageCopy) {
        <span matListItemLine class="email-copy__copy">
          {{pushMessageCopy}}
        </span>
      }
      <button mat-icon-button matListItemMeta>
        <img alt="Chevron Icon"
          class="email-copy__chevron-icon"
          src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
      </button>
    </mat-list-item>
  }
</mat-list>
